// extracted by mini-css-extract-plugin
export default {"RoundButton":"RoundButton_RoundButton__L+ef2","transparent":"RoundButton_transparent__DFqsy","copiedMessage":"RoundButton_copiedMessage__-R3bp"};